<template>
  <div class="personal">
    <div class="page-loader" v-if="pageLoading">
      <div>
        <PageLoader />
      </div>
      <p v-if="networkErr">Server error. Please try again later.</p>
    </div>

    <div class="personal_container" v-if="!pageLoading">
      <div class="personal_border">
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            First Name
            <span>*</span>
          </div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.firstname" />
          </div>
        </div>
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Last Name
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.lastname" />
          </div>
        </div>
      </div>

      <div class="personal_border">
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Gender
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <select v-model="jobseeker.gender">
              <option value="">-- select --</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>
        </div>
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Birthday
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input type="date" v-model="jobseeker.date_of_birth" />
          </div>
        </div>
      </div>

      <div class="personal_border">
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Email Address
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input readonly type="text" v-model="jobseeker.email" />
          </div>
        </div>
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Phone Number
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.phone" />
          </div>
        </div>
      </div>

      <div class="personal_border">
        <div class="personal_half_form">
          <div class="personal_half_form_label">Alternate Phone Number:</div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.alt_phone" />
          </div>
        </div>
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Home Address
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.address" />
          </div>
        </div>
      </div>

      <div class="personal_noborder">
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            State
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <select v-model="jobseeker.state_id">
              <option value>Select Your State</option>
              <option
                v-for="(val, index) in state"
                :key="index"
                :value="val.id"
              >
                {{ val.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Local Government
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <select v-model="jobseeker.city_id">
              <option v-for="(val, index) in city" :key="index" :value="val.id">
                {{ val.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="personal_noborder">
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Emergency Contact
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.contact_person" />
          </div>
        </div>
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Emergency Contact Relationship
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.contact_relationship" />
          </div>
        </div>
      </div>
      <div class="personal_border">
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Emergency Contact Phone Number
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.contact_phone" />
          </div>
        </div>
        <div class="personal_half_form">
          <div class="personal_half_form_label">
            Emergency Contact Address
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.contact_address" />
          </div>
        </div>
      </div>

      <div class="personal_noborder">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">
            What role do you currently work in?
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <select v-model="jobseeker.jobrole_id">
              <option v-for="(val, index) in jobs" :key="index" :value="val.id">
                {{ val.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="personal_noborder">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">
            If others, type your role in the box:
          </div>
          <div class="personal_half_form_input">
            <input type="text" />
          </div>
        </div>
      </div>
      <div class="personal_noborder">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">
            How much was your last monthly salary or how much do you currently
            earn monthly?
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input
              type="text"
              v-model="jobseeker.current_pay"
              style="padding-left: 45px"
            />
            <div>&#8358;</div>
          </div>
        </div>
      </div>
      <div class="personal_noborder">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">
            How many years experience do you have?
            <span>*</span>
          </div>
          <div class="personal_half_form_input">
            <select v-model="jobseeker.experience_years">
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
          </div>
        </div>
      </div>
      <div class="personal_noborder">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">
            What bank do you use?
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <select v-model="jobseeker.bank_id">
              <option
                v-for="(val, index) in banks"
                :key="index"
                :value="val.id"
              >
                {{ val.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="personal_noborder">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">
            Bank Account Number
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input
              type="number"
              v-model="jobseeker.bank_account_number"
              @change="resolveAccountName"
              @keyup="bankInfoError = null"
            />
          </div>
          <div class="personal__error">
            <span v-if="bankInfoError">{{ bankInfoError }}</span>
          </div>
        </div>
      </div>

      <div class="personal_border">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">
            Account Name
            <span>*</span>:
          </div>
          <div class="personal_half_form_input">
            <input readonly type="text" v-model="jobseeker.bank_account_name" />
          </div>
        </div>
      </div>

      <div class="personal_noborder">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">Do you have a pension?</div>
          <div class="personal_half_form_input">
            <select v-model="pension" @change="selectPension">
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </select>
          </div>
        </div>
      </div>

      <div class="personal_noborder" v-if="showPension">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">
            What PFA (Pension Administrator) Are You Registered With?
            <p>*Please skip if you don't have</p>
          </div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.pfa" />
          </div>
        </div>
      </div>

      <div class="personal_noborder" v-if="showPension">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">PFA Number:</div>
          <div class="personal_half_form_input">
            <input type="text" v-model="jobseeker.pfa_number" />
          </div>
        </div>
      </div>

      <div class="personal_noborder">
        <div class="personal_quarter_form">
          <div class="personal_half_form_label">Upload Passport Picture:</div>
          <div class="personal_half_form_image">
            <p v-show="!uploadedFile">
              <font-awesome-icon icon="upload" />&nbsp;browse to select
            </p>
            <p v-show="uploadedFile">{{ uploadedFileName }}</p>
            <input type="file" ref="avatar" accept="image/*" @change="uploadAvatar" />
          </div>
        </div>
        <div class="uploaded__passport">

          <img v-if="this.uploadedPassport" :src="this.uploadedPassport" alt="">
        </div>
      </div>

      <div class="personal__error">
        <span v-if="showErr">{{ ErrMessage }}</span>
        <span v-if="noFile"
          >Please uplaod a png or jpg file of not more than 1mb.</span
        >
        <span v-if="fileSize">File must not be more than 500kb.</span>
        <span v-if="networkErr">Server error. Please try again later.</span>
      </div>

      <div class="personal_noborder">
        <div class="personal_half_form">
          <div
            class="personal_half_form_btn"
            v-if="!btnLoading"
            @click="submitUpdatedProfile"
          >
            Save & Proceed
          </div>
          <div class="personal_half_form_btn" v-if="btnLoading">
            <WhiteLoader />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../../store/constant";
import PageLoader from "../../../partials/page-loader";
import WhiteLoader from "../../../partials/white-loader";

export default {
  name: "Personal",
  components: {
    PageLoader,
    WhiteLoader,
  },
  data() {
    return {
      pageLoading: true,
      btnLoading: false,
      uploadedFile: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      uploadedPassport: null,
      fileExt: "",
      noFile: false,
      fileSize: false,
      networkErr: false,
      showErr: false,
      ErrMessage: null,
      state: [],
      city: [],
      jobs: [],
      banks: [],
      pension: "no",
      showPension: false,
      defaultState: "",
      bankInfoError: null,
      jobseeker: {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        date_of_birth: "",
        gender: "",
        address: "",
        alt_phone: "",
        jobrole_id: "",
        current_pay: "",
        contact_person: "",
        contact_phone: "",
        contact_address: "",
        contact_relationship: "",
        country_id: 160,
        state_id: "",
        city_id: "",
        experience_years: "",
        bank_id: "",
        bank_account_number: "",
        bank_account_name: "",
        pfa: "",
        pfa_number: "",
      },
    };
  },
  methods: {
    showDocument() {
      this.$emit("clickedDocument");
    },
    resolveAccountName() {
      this.bankInfoError = null;
      this.jobseeker.bank_account_name = "";

      if (!this.jobseeker.bank_account_number.match(/^[0-9]+$/)) {
        this.bankInfoError = "The account number must contain only numbers";
        return;
      }

      if (this.jobseeker.bank_account_number.length !== 10) {
        return;
      }

      let data = {
        account_number: this.jobseeker.bank_account_number,
        bank_id: this.jobseeker.bank_id,
      };

      // this.gettingBankName = true;

      this.$http
        .post(types.ACCOUNTS_API, data)
        .then((resp) => {
          this.jobseeker.bank_account_name = resp.data.data.account_name;
        })
        .catch((err) => {
          this.bankInfoError = "Unable to get bank name";

        });
    },
    getProfile() {
      this.$http
        .get(types.GET_PROFILE)
        .then((resp) => {
          this.jobseeker = {
            firstname: resp.data.firstname,
            lastname: resp.data.lastname,
            email: resp.data.email,
            phone: resp.data.phone,
            date_of_birth: resp.data.date_of_birth,
            gender: resp.data.gender,
            address: resp.data.address,
            alt_phone: "",
            jobrole_id: "",
            current_pay: "",
            contact_person: "",
            contact_phone: "",
            contact_address: "",
            contact_relationship: "",
            country_id: 160,
            state_id: "",
            city_id: "",
            experience_years: "",
            bank_id: "",
            bank_account_number: "",
            bank_account_name: "",
          };

          if (resp.data.jobseekers) {
            this.jobseeker.alt_phone = resp.data.jobseekers.alt_phone;
            this.jobseeker.jobrole_id = resp.data.jobseekers.jobrole_id;
            this.jobseeker.current_pay = resp.data.jobseekers.current_pay;
            this.jobseeker.contact_person = resp.data.jobseekers.contact_person;
            this.jobseeker.contact_phone = resp.data.jobseekers.contact_phone;
            this.jobseeker.contact_address =
              resp.data.jobseekers.contact_address;
            this.jobseeker.contact_relationship =
              resp.data.jobseekers.contact_relationship;
            this.jobseeker.country_id = 160;
            this.jobseeker.state_id = resp.data.jobseekers.state_id;
            this.jobseeker.city_id = resp.data.jobseekers.city_id;
            this.jobseeker.experience_years =
              resp.data.jobseekers.experience_years;
            this.jobseeker.bank_id = resp.data.jobseekers.bank_id;
            this.jobseeker.bank_account_number =
              resp.data.jobseekers.bank_account_number;
            this.jobseeker.bank_account_name =
              resp.data.jobseekers.bank_account_name;
            this.jobseeker.pfa = resp.data.jobseekers.pfa;
            this.jobseeker.pfa_number = resp.data.jobseekers.pfa_number;
            this.$store.state.jobseekerPassport = resp.data.jobseekers.passport;
            this.uploadedPassport = resp.data.jobseekers.passport;
          }
          this.getState();
        })
        .catch((err) => {
          this.networkErr = true;
        });
    },
    getState() {
      this.$http
        .get(types.GET_STATE)
        .then((resp) => {
          this.state = [...resp.data.data];
          for (let index of this.state) {
            if (index.name.toLowerCase() === "lagos") {
              this.defaultState = index.id;
              this.jobseeker.state_id = index.id;
            }
          }
          this.getCity();
        })
        .catch((err) => {
          this.networkErr = true;
        });
    },
    getCity() {
      this.$http
        .get(`${types.GET_CITIES}/${this.defaultState}`)
        .then((resp) => {
          this.city = [...resp.data.data];
          this.jobseeker.city_id = this.city[0].id;
          this.getJobRoles();
        })
        .catch((err) => {
          this.networkErr = true;
        });
    },
    getJobRoles() {
      this.$http
        .get(types.GET_JOB_ROLES)
        .then((resp) => {
          this.jobs = [...resp.data.data];
          if (!this.jobseeker.jobrole_id) {
            this.jobseeker.jobrole_id = this.jobs[0].id;
          }
          this.getBanks();
        })
        .catch((err) => {
          this.networkErr = true;
        });
    },
    getBanks() {
      this.$http
        .get(types.BANKS_API)
        .then((resp) => {
          this.banks = [...resp.data.data];
          this.pageLoading = false;
        })
        .catch((err) => {
          this.networkErr = true;
        });
    },
    selectPension() {
      if (this.pension === "yes") {
        this.showPension = true;
      } else {
        this.showPension = false;
      }
    },
    uploadAvatar() {
      this.showErr = false;
      this.uploadedFile = false;
      this.noFile = false;
      this.fileSize = false;
      this.networkErr = false;
      this.noEmployee = false;
      this.fileName = this.$refs.avatar;
      this.file = this.$refs.avatar.files[0];
      this.fileExt = this.fileName.value.split(".").pop();

      if (this.file) {
        this.uploadedFileName = this.fileName.value.split("\\").pop();
        this.uploadedFile = true;
      }
    },
    submitUpdatedProfile() {
      this.showErr = false;
      this.ErrMessage = null;
      for (const key of Object.keys(this.jobseeker)) {
        if (key !== "pfa" && key !== "alt_phone" && key !== "pfa_number") {
          if (!this.jobseeker[key]) {
            this.showErr = true;
            this.ErrMessage =
              "Fields marked red are required but some are empty.";
            return;
          }
        }
      }

      const expression = /\S+@\S+\.\S+/;
      if (!expression.test(this.jobseeker.email)) {
        this.showErr = true;
        this.ErrMessage = "Please enter your email address";
        return;
      }

      if (isNaN(this.jobseeker.phone)) {
        this.showErr = true;
        this.ErrMessage = "Please enter your phone  number";
        return;
      }

      if (this.jobseeker.alt_phone) {
        if (isNaN(this.jobseeker.alt_phone)) {
          this.jobseeker.alt_phone = 123456789;
        }
      }

      if (isNaN(this.jobseeker.contact_phone)) {
        this.showErr = true;
        this.ErrMessage = "Please enter your emergency contact phone  number";
        return;
      }

      if (isNaN(this.jobseeker.current_pay)) {
        this.showErr = true;
        this.ErrMessage = "Your Current pay must be numbers";
        return;
      }

      if (isNaN(this.jobseeker.bank_account_number)) {
        this.showErr = true;
        this.ErrMessage = "Please enter your bank account number ";
        return;
      }


      if (this.file && this.fileExt) {
        if (
          this.fileExt.toLowerCase().trim() === "png" ||
          this.fileExt.toLowerCase().trim() === "jpg"
        ) {
          if (this.file.size > 500000) {
            this.fileSize = true;
            return;
          }
        }
      }



      this.btnLoading = true;

      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("firstname", this.jobseeker.firstname);
      formData.append("lastname", this.jobseeker.lastname);
      formData.append("date_of_birth", this.jobseeker.date_of_birth);
      formData.append("gender", this.jobseeker.gender);
      formData.append("address", this.jobseeker.address);
      formData.append("alt_phone", this.jobseeker.alt_phone);
      formData.append("jobrole_id", this.jobseeker.jobrole_id);
      formData.append("current_pay", this.jobseeker.current_pay);
      formData.append("contact_person", this.jobseeker.contact_person);
      formData.append("contact_phone", this.jobseeker.contact_phone);
      formData.append("contact_address", this.jobseeker.contact_address);
      formData.append(
        "contact_relationship",
        this.jobseeker.contact_relationship
      );
      formData.append("country_id", this.jobseeker.country_id);
      formData.append("state_id", this.jobseeker.state_id);
      formData.append("city_id", this.jobseeker.city_id);
      formData.append("experience_years", this.jobseeker.experience_years);
      formData.append("bank_id", this.jobseeker.bank_id);
      formData.append(
        "bank_account_number",
        this.jobseeker.bank_account_number
      );
      formData.append("bank_account_name", this.jobseeker.bank_account_name);
      formData.append("pfa", this.jobseeker.pfa);
      formData.append("pfa_number", this.jobseeker.pfa_number);

      this.$http
        .post(types.UPDATE_PROFILE, formData)
        .then((resp) => {
          this.showDocument();
        })
        .catch((err) => {
          this.showErr = true;
          this.ErrMessage = "Server error, please try again.";
          this.btnLoading = false;
        });
      //   return;
      // }
      // this.noFile = true;
    },
  },
  created() {
    this.getProfile();
  },
};
</script>

<style lang="scss" scoped>
.personal {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 0 50px 20px 50px;

  @media (max-width: 800px) {
    padding: 10px;
  }

  > .page-loader {
    padding-top: 30px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    align-content: center;

    > div {
      width: 55px;
    }
  }

  > .personal_container {
    > .personal_border {
      padding: 30px 0;
      border-bottom: 1px solid #ccc;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      align-content: center;

      > .personal_half_form {
        width: 45%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;
        margin-bottom: 20px;

        @media (max-width: 1200px) {
          width: 47%;
        }

        @media (max-width: 700px) {
          width: 100%;
        }

        > .personal_half_form_label {
          width: 150px;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.19;
          letter-spacing: normal;
          text-align: left;
          color: #707070;
          padding-right: 5px;

          > span {
            color: red;
          }
        }

        > .personal_half_form_input {
          width: calc(100% - 150px);
          min-width: 100px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;

          > input {
            border: 0;
            outline: 0;
            height: 40px;
            padding: 0 5px;
            background: transparent;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            color: #000000;
          }

          > select {
            border: 0;
            outline: 0;
            height: 40px;
            padding: 0 5px;
            background: transparent;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            color: #000000;
          }
        }
      }

      > .personal_quarter_form {
        width: 60%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        @media (max-width: 1200px) {
          width: 80%;
        }

        @media (max-width: 700px) {
          width: 100%;
        }

        > .personal_half_form_label {
          width: 250px;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.19;
          letter-spacing: normal;
          text-align: left;
          color: #707070;
          padding-right: 5px;

          > span {
            color: red;
          }
        }

        > .personal_half_form_input {
          width: calc(100% - 250px);
          min-width: 250px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;

          > input {
            border: 0;
            outline: 0;
            height: 40px;
            padding: 0 5px;
            background: transparent;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            color: #000000;
          }

          > select {
            border: 0;
            outline: 0;
            height: 40px;
            padding: 0 5px;
            background: transparent;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            color: #000000;
          }
        }
      }
    }

    > .personal_noborder {
      padding: 30px 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      align-content: center;

      > .personal_half_form {
        width: 45%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;
        margin-bottom: 20px;

        @media (max-width: 700px) {
          width: 100%;
        }

        > .personal_half_form_label {
          width: 150px;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.19;
          letter-spacing: normal;
          text-align: left;
          color: #707070;
          padding-right: 5px;

          > span {
            color: red;
          }
        }

        > .personal_half_form_btn {
          max-width: 200px;
          border-radius: 5px;
          background-color: #5099de;
          height: 40px;
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.21;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }

        > .personal_half_form_input {
          width: calc(100% - 150px);
          min-width: 250px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;

          > input {
            border: 0;
            outline: 0;
            height: 40px;
            padding: 0 5px;
            background: transparent;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            color: #000000;
          }

          > select {
            border: 0;
            outline: 0;
            height: 40px;
            padding: 0 5px;
            background: transparent;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            color: #000000;
          }
        }
      }

      > .personal_quarter_form {
        width: 60%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        @media (max-width: 1200px) {
          width: 80%;
        }

        @media (max-width: 700px) {
          width: 100%;
        }

        > .personal_half_form_label {
          width: 250px;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.19;
          letter-spacing: normal;
          text-align: left;
          color: #707070;
          padding-right: 5px;

          > span {
            color: red;
          }

          > p {
            font-size: 10px;
            font-weight: normal;
            font-stretch: normal;
            font-style: italic;
            line-height: 2.08;
            letter-spacing: normal;
            text-align: left;
            color: #707070;
            margin: 5px 0 0 0;
          }
        }

        > .personal_half_form_input {
          width: calc(100% - 250px);
          min-width: 250px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          position: relative;

          > div {
            position: absolute;
            left: 0;
            top: 0;
            height: 40px;
            width: 40px;
            border-right: solid 1px #c7c7c7;
            background-color: #fafafa;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }

          > input {
            border: 0;
            outline: 0;
            height: 40px;
            padding: 0 5px;
            background: transparent;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            color: #000000;
          }

          > select {
            border: 0;
            outline: 0;
            height: 40px;
            padding: 0 5px;
            background: transparent;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            color: #000000;
          }
        }

        > .personal_half_form_image {
          width: calc(100% - 250px);
          min-width: 250px;
          border: dashed 1px #5099de;
          background-color: #ffffff;

          position: relative;

          > p {
            margin: 0;
            padding: 20px;
            font-size: 16px;
            font-weight: 200;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;
          }

          > input {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.personal__error {
  > span {
    color: red;
    font-size: 13px;
    font-style: italic;
  }
}

.uploaded__passport {
  width: 300px;
  > img {
    width: 100%;
  }
}
</style>
